
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface ProductFormSupplierProps {
  supplierName: string;
  setSupplierName: (name: string) => void;
  supplierWebsite: string;
  setSupplierWebsite: (website: string) => void;
  supplierContact: string;
  setSupplierContact: (contact: string) => void;
  productCode: string;
  setProductCode: (code: string) => void;
}

const ProductFormSupplier = ({
  supplierName,
  setSupplierName,
  supplierWebsite,
  setSupplierWebsite,
  supplierContact,
  setSupplierContact,
  productCode,
  setProductCode,
}: ProductFormSupplierProps) => {
  return (
    <div className="space-y-4">
      <h3 className="text-sm font-medium">Supplier Information (optional)</h3>
      
      <div className="space-y-2">
        <Label htmlFor="supplier-name">Supplier Name</Label>
        <Input
          id="supplier-name"
          value={supplierName}
          onChange={(e) => setSupplierName(e.target.value)}
          placeholder="e.g., Medical Supply Co."
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="supplier-website">Supplier Website</Label>
        <Input
          id="supplier-website"
          value={supplierWebsite}
          onChange={(e) => setSupplierWebsite(e.target.value)}
          placeholder="e.g., https://supplier.com"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="supplier-contact">Supplier Contact</Label>
        <Input
          id="supplier-contact"
          value={supplierContact}
          onChange={(e) => setSupplierContact(e.target.value)}
          placeholder="e.g., support@supplier.com"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="product-code">Product Code</Label>
        <Input
          id="product-code"
          value={productCode}
          onChange={(e) => setProductCode(e.target.value)}
          placeholder="e.g., SM-123456"
        />
      </div>
    </div>
  );
};

export default ProductFormSupplier;
